export default "__VITE_ASSET__CGcUodAQ__"